import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { BookingSlot } from '../../../booking/models/booking-slot';
import { BookingSlotStateService } from '../../../booking/services/booking-slot-state.service';
import { BookingOrderService } from '../../../booking/services/booking-order.service';
import { ShopSettingsService } from '../../services/shop-settings.service';
import { TimeSlotDisplayType } from '../../models/time-slot-display-type.enum';

@Component({
  selector: 'app-time-slots',
  templateUrl: './time-slots.component.html',
  styleUrls: ['./time-slots.component.css']
})
export class TimeSlotsComponent implements OnInit {

  @Input()
  timeSlots: BookingSlot[];
  @Input()
  isUserChangeDate: false;

  @Output()
  timeSlotSelected: EventEmitter<BookingSlot> = new EventEmitter<BookingSlot>();

  constructor(
    private bookingOrderService: BookingOrderService,
    private shopSettingsService: ShopSettingsService,
  ) { }

  ngOnInit() {
  }

  onClickTimeSlot(timeSlot: BookingSlot) {
    this.timeSlotSelected.emit(timeSlot);
  }

  getAreaItemsTimeMinutes(bookingSlot: BookingSlot): number[] {
    if (!bookingSlot || !bookingSlot.availableAreaItemsIds || !this.bookingOrderService.areaItems) {
      return [];
    }

    return this.bookingOrderService.areaItems
      .filter(areaItem => bookingSlot.availableAreaItemsIds.includes(areaItem.id))
      .map(areaItem => areaItem.minutes)
      .filter(this.onlyUnique);
  }

  getAreaItemAvailableQuantity(bookingSlot: BookingSlot, minutes: number): number {
    if (!bookingSlot || !bookingSlot.availableAreaItemsIds || !this.bookingOrderService.areaItems) {
      return 0;
    }

    const areItemIds = this.bookingOrderService.areaItems
      .filter(areaItem => bookingSlot.availableAreaItemsIds.includes(areaItem.id) && areaItem.minutes === minutes)
      .map(areaItem => areaItem.id);

    let availableQuantity = bookingSlot.freeQuantity;
    if (areItemIds.length !== 0 && bookingSlot.bookedDetailQuantity != null) {
      const bookedDetailQuantity = bookingSlot.bookedDetailQuantity.filter(item => areItemIds.includes(item.areaItemId));
      if (bookedDetailQuantity.length !== 0) {
        for (const bookedQuantity of bookedDetailQuantity) {
          availableQuantity = Math.min(bookedQuantity.availableQuantity, availableQuantity);
        }
      }
    }

    return availableQuantity > 0 ? availableQuantity : 0;
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  get isShowTimeSlotLength(): boolean {
    return this.timeSlotBoxType !== TimeSlotDisplayType.TimePeriod;
  }

  private get timeSlotBoxType(): string {
    return this.shopSettingsService?.shopSettings?.timeSlotDisplayType || TimeSlotDisplayType.Default;
  }

  get isShowAvailableTicketsInTimeSlot(): boolean {
    return this.shopSettingsService.shopSettings.showAvailableTicketsInTimeSlot;
  }
}
